export default "__VITE_ASSET__TfEeKxSP__";